@if (!isMobile) {
  <div class="section-top-header ui-mobile-AirDisc">Value Calculator</div>
}
@if (isMobile) {
  <div class="section-top-header ui-mobile-AirDisc"  (click)="iconToggler =! iconToggler">{{ 'common.airDisc_value_calculator_title' | cxTranslate }}</div>
}
@if (isMobile?!iconToggler:true) {
  <ul class="my-account-nav mobile-account-nav" >
    <li class="parentLI">
      <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'visitorInfo'?'active':''" href="#visitorInfo" (click)="SelectedComponent('visitorInfo',$event)">{{ 'common.value_calculator_visitor_info_title' | cxTranslate }}
        @if (currentComponent === 'visitorInfo') {
          <img src="/icons/link-right-blue.svg" class="right-arrow">
        }</a>
      </li>
      <li class="parentLI">
        <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'fleetInfo'?'active':''"  href="#fleetInfo" (click)="SelectedComponent('fleetInfo',$event)">{{ 'common.value_calculator_flit_info_title' | cxTranslate }}
          @if (currentComponent === 'fleetInfo') {
            <img src="/icons/link-right-blue.svg" class="right-arrow">
          }</a>
        </li>
        <li class="parentLI">
          <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'maintaince'?'active':''"href="#maintaince" (click)="SelectedComponent('maintaince',$event)">{{ 'common.smartire_maintaince' | cxTranslate }}
            @if (currentComponent === 'maintaince') {
              <img src="/icons/link-right-blue.svg" class="right-arrow">
            }</a>
          </li>
          <li class="parentLI">
            <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'savings'?'active':''" href="#savings" (click)="SelectedComponent('savings',$event)">{{ 'common.smartire_savings' | cxTranslate }}
              @if (currentComponent === 'savings') {
                <img src="/icons/link-right-blue.svg" class="right-arrow">
              }</a>
            </li>
          </ul>
        }
